import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CustomQuoteSection from '../components/CustomQuoteSection';

const CustomQuote: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#3C59B2]/10">
      <Header />
      <CustomQuoteSection />
      <Footer />
    </div>
  );
};

export default CustomQuote;

